import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { Environment } from "@omni/types/enums/environment.enum";
import { DeepPartial } from "@omni/types/utils/deepPartial";
import { ModelMapper } from "@omni/types/utils/modelMapper";
import { values } from "@omni/utils/object.utils";
import * as yup from "yup";

import { yupBaseStoreAware } from "../common/baseStoreAware.schema";

export type RawContractsConfig = {
    // BaseStore agnostic
    ENV: Environment;

    // BaseStore aware
    HUBO_BFF_ENDPOINT: string;
    ETNA_BFF_ENDPOINT: string;
};

const toContractsConfig: ModelMapper<
    DeepPartial<RawContractsConfig>,
    DeepPartial<ContractsConfig>
> = (config) => {
    return {
        // BaseStore agnostic
        environment: config.ENV,

        // BaseStore aware
        bffEndpoint: {
            [BaseStore.Hubo]: config.HUBO_BFF_ENDPOINT,
            [BaseStore.Etna]: config.ETNA_BFF_ENDPOINT
        }
    };
};
export const ContractsConfigSchema = yup
    .object()
    .transform((_, rawConfig: DeepPartial<RawContractsConfig>) => {
        return toContractsConfig(rawConfig);
    })
    .shape({
        // BaseStore agnostic
        environment: yup
            .mixed<Environment>()
            .oneOf(values(Environment))
            .required(),

        // BaseStore aware
        bffEndpoint: yupBaseStoreAware(yup.string().required())
    });

export type ContractsConfig = yup.InferType<typeof ContractsConfigSchema>;
